/**
 * Microsoft Clarity Analytics Integration
 * 
 * Provides user behavior tracking including:
 * - Session recordings
 * - Heatmaps
 * - User interactions
 * - Page analytics
 */

export const initializeClarity = () => {
  const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  
  // Only initialize if project ID is configured
  if (!clarityProjectId || clarityProjectId === 'YOUR_CLARITY_PROJECT_ID') {
    console.log('Microsoft Clarity: Not initialized (Project ID not configured)');
    return;
  }

  // Check if Clarity is already loaded
  if (window.clarity) {
    console.log('Microsoft Clarity: Already initialized');
    return;
  }

  try {
    // Clarity tracking code
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", clarityProjectId);

    console.log('Microsoft Clarity: Initialized successfully');
  } catch (error) {
    console.error('Microsoft Clarity: Failed to initialize', error);
  }
};

/**
 * Track custom events in Clarity
 * @param {string} eventName - Name of the event
 * @param {object} eventData - Additional data for the event
 */
export const trackClarityEvent = (eventName, eventData = {}) => {
  if (window.clarity) {
    try {
      window.clarity('event', eventName, eventData);
      console.log(`Clarity Event: ${eventName}`, eventData);
    } catch (error) {
      console.error('Clarity Event Error:', error);
    }
  }
};

/**
 * Identify user in Clarity
 * @param {string} userId - Unique user identifier
 * @param {string} sessionId - Session identifier (optional)
 * @param {string} pageId - Page identifier (optional)
 */
export const identifyClarityUser = (userId, sessionId, pageId) => {
  if (window.clarity) {
    try {
      window.clarity('identify', userId, sessionId, pageId);
      console.log(`Clarity User Identified: ${userId}`);
    } catch (error) {
      console.error('Clarity Identify Error:', error);
    }
  }
};

/**
 * Set custom tags in Clarity
 * @param {string} key - Tag key
 * @param {string} value - Tag value
 */
export const setClarityTag = (key, value) => {
  if (window.clarity) {
    try {
      window.clarity('set', key, value);
      console.log(`Clarity Tag: ${key} = ${value}`);
    } catch (error) {
      console.error('Clarity Tag Error:', error);
    }
  }
};
